import { useMemo, useState } from "react";

// Removed AdminLayout import
import { Button } from "@/components/ui/button";
import { PasskeySettings } from "@/components/settings/passkey-settings";
import { PasswordSettings } from "@/components/settings/password-settings";
import { ProfileInformationSettings } from "@/components/settings/profile-information-settings";
import { SessionSettings } from "@/components/settings/session-settings";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type SettingsSection = "profile" | "password" | "passkeys" | "sessions";

export function ProfileSettingsPage() {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] =
    useState<SettingsSection>("profile");

  const sidebarNavItems = useMemo(() => [
    {
      key: "profile" as SettingsSection,
      title: t("profileSettings.navProfile", "Profile"),
    },
    {
      key: "password" as SettingsSection,
      title: t("profileSettings.navPassword", "Password"),
    },
    {
      key: "passkeys" as SettingsSection,
      title: t("profileSettings.navPasskeys", "Passkeys"),
    },
    {
      key: "sessions" as SettingsSection,
      title: t("profileSettings.navSessions", "Sessions"),
    },
  ], [t]);

  const settingsComponents: Record<SettingsSection, React.ComponentType> = {
    profile: ProfileInformationSettings,
    password: PasswordSettings,
    passkeys: PasskeySettings,
    sessions: SessionSettings,
  };

  const ActiveSettingsComponent = settingsComponents[activeSection];

 return (
   // Replace AdminLayout with container div, similar to admin/users page
   <div className="container mx-auto py-10">
     {/* Keep the inner flex structure for side nav + main content */}
     <div className="flex flex-col md:flex-row md:gap-8">
       <aside className="w-full md:w-48 lg:w-56 shrink-0 mb-8 md:mb-0">
         <nav className="flex flex-col gap-1">
          {sidebarNavItems.map((item) => (
            <Button
              key={item.key}
              variant="ghost"
              onClick={() => setActiveSection(item.key)}
              className={cn(
                "block w-full justify-start rounded-md p-2 text-base text-left",
                activeSection === item.key
                  ? "bg-muted font-semibold text-foreground"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground",
              )}
            >
              {item.title}
            </Button>
          ))}
        </nav>
      </aside>

      <main className="flex-1">
        <h1 className="text-2xl font-semibold mb-6">
          {t("profileSettings.title", "Profile Settings")}
        </h1>
        <ActiveSettingsComponent key={activeSection} />
      </main>
     </div>
     {/* Removed AdminLayout wrapper */}
   </div>
 );
}

export default ProfileSettingsPage;
